<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        div.online-users-control(v-if="loaded")
            profile-files-container-control(v-if="screenSM" title="Online" :actionTitle="actionTitle" @defaultAction="switchShow")
                template(v-slot:actions v-if="!showSwitcher")
                    div
                
                template
                    div.online-users-control__grid(v-if="users.length > 0")
                        creator-control.online-users-control__grid-item(v-for="index in showCount" :key="index" :creator="users[index - 1]" :compact="true")
                    div.online-users-control__empty(v-else) There are no contacts online.
            
            div.online-users-control__grid(v-else-if="users.length > 0")
                creator-control.online-users-control__grid-item(v-for="index in showCount" :key="index" :creator="users[index - 1]" :compact="true")
            div.online-users-control__empty(v-else) There are no contacts online.
</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'
import usersOnline from '../../services/online-users-service'

const SHOW_COUNT_MIN = 4

export default {
    name: 'online-users-control',

    components: {
        MatchMedia,
    },

    data() {
        return {
            loaded: false,
            users: [],
            showAll: false,
        }
    },

    computed: {
        actionTitle() {
            return this.showAll ? 'See less' : 'See all'
        },

        showCount() {
            if (this.users.length < SHOW_COUNT_MIN) {
                return this.users.length
            }
            return this.showAll ? this.users.length : SHOW_COUNT_MIN
        },

        showSwitcher() {
            return this.users.length > SHOW_COUNT_MIN
        },
    },

    methods: {
        switchShow() {
            this.showAll = !this.showAll
        },

        async getOnlineUsers() {
            const { data: { data } } = await usersOnline.list()
            this.users = data
            this.loaded = true
        },
    },

    created() {
        this.getOnlineUsers()
    },
}
</script>
